import { cssThemedValue } from '@creditornot/cb-ingredients';
import styled, { css } from 'styled-components';

import { Typography as T } from 'common/typography';

import { BREAKPOINT_MOBILE } from './breakpoints';

export const Heading = styled(T.Heading1)`
  text-align: center;
  align-self: center;
  color: ${cssThemedValue('textPrimary')};

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    font-size: 40px;
    line-height: 1.15;
  }
`;

const Centered = css`
  display: flex;
  flex-grow: 1;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  gap: 32px;
`;

export const CenteredRoot = styled.main`
  ${Centered}
  background-color: ${cssThemedValue('surfaceMain')};
`;

export const CenteredContent = styled.section`
  ${Centered}
  padding-block-start: 80px;
  padding-block-end: 80px;
`;

export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const Content = styled.section`
  display: flex;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  width: 100%;
  max-width: 616px;
  padding: 16px;
  margin: 0 auto;

  margin-block-start: 80px;
  margin-block-end: 80px;
`;

export const IllustrationContainer = styled.div`
  height: 214px;
`;
